export default "__VITE_PUBLIC_ASSET__db1d837e__"